<template>
  <main id="community_body" v-show="startRender">
    <top-menu :top_title="top_title"></top-menu>
    <div class="div_padding"></div>
    <div class="wrapper">
      <div class="main_text_box">
        <h3>활동만 해도 <span id="thehae">더해</span>져요.</h3>
        <h3>한번만 말고 계속 <span id="thehae">더해</span>봐요.</h3>
      </div>
      <div class="attendance" id="community_top">
        <swiper class="swiper" :options="communitySwiperOption">
          <swiper-slide v-for="list in banner" :key="list.bnId">
            <img v-bind:src="list.bnImageUrl != undefined ? list.bnImageUrl : 'images/banner/sub_banner_dummy.png'" 
                  onerror="this.src='images/banner/sub_banner_dummy.png'" alt="" @click="goToDetailPage(list)"/>
          </swiper-slide>
          <div id="community_progress" class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="ul_menu_div">
        <ul class="menu_ul">
          <li v-for="(menu, i) in resultList" :key="i" :id="menu.boardId" @click="selectBoardList(menu.boardId)" :class="boardId == menu.boardId ? 'active' : ''">{{ menu.boardNm }}</li>
        </ul>
      </div>
      <div id="community_list_div" class="list_div">
        <div id="board_list" v-if="listCnt != 0">
          <div class="list_li" v-for="(list, i) in board" @click="community_view(list.nttId)" :key="i" v-show="!reportUsers.includes(list.regId)">
            <div class="nttId" style="display: none"></div>
            <div class="num">{{ i + 1 }}</div>
            <p class="content" v-html="list.nttSj"></p>
            <template v-if="list.commentAt == 'Y' & list.commentCnt > 0">
              <span class="reply">+</span><span class="reply" v-text="list.commentCnt"></span>
            </template>
          </div>
        </div>
        <div v-else>
          <div class="unlisted_wrap">
            <img src="images/basic/img/no-article.svg" />
            <p class="title">등록된 글이 없습니다.</p>
            <span class="sub_title">{{ this.$store.state.userInfo.name }}님 지금 글을 등록해보세요!</span>
          </div>
        </div>

        <div></div>
        <div class="notice_div">
          <table>
            <tr v-for="notice in noticeList" :key="notice.nttId" @click="goToDetailPage(notice)">
              <th><img src="images/basic/icon/notice.svg" /> {{ notice.boardNm }}</th>
              <td class="content">{{ notice.nttSj }}</td>
              <td class="more"><img src="images/basic/icon/arrow-right-thin.svg" alt="" /></td>
            </tr>
          </table>
        </div>
        <!-- 광고 -->
        <div class="app_extanal">
          <img src="images/basic/img/external_img.png" alt="" style="visibility: hidden" />
        </div>

        <div id="community_board_list" v-show="listCnt !== 0">
          <div class="" v-for="(community, c_idx) in boardDetailList" :key="c_idx">
            <div class="board_wrapper">
              <div class="main_board">
                <div class="board_list" v-for="(board, idx) in community" :key="idx">
                  <div class="list_sort" v-show="idx == 0">
                    <p>{{ community[0].dateWeek }}</p>
                  </div>
                  <!--<div @click="community_view(board.nttId)" class="board_preview" > origin -->
                  <div @click="community_view(board.nttId)" class="board_preview" v-show="!reportUsers.includes(board.regId)">
                    <div class="nttId" style="display: none">{{ board.nttId }}</div>
                    <div class="preview_text">
                      <p><span class="category" v-html="board.boardNm"></span><span class="ctn" v-html="board.nttSj"></span></p>
                    </div>
                    <template v-if="board.imgViewList != undefined">
                      <template v-if="board.imgViewList.length > 0">
                        <div class="preview_img"  style="padding-top: 5px">
                          <img :src="board.imgViewList[0].viewUrl" alt="" style="width: 100%; height: auto" />
                        </div>
                      </template>
                    </template>
                    <!--
                    <div class="preview_img" v-for="(img, idx) in board.imgViewList" :key="idx" style="padding-top: 5px">
                      <img :src="img.viewUrl" alt="" style="width: 100%; height: auto" />
                    </div>
                    -->
                    <!-- <div class="preview_img" v-if="board.video">
                                      <iframe width="100%" height="177" v-bind:src="board.video"
                                              title="YouTube video player" frameborder="0"
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                              allowfullscreen></iframe>
                                  </div> -->
                    <div class="preview_reply">
                      <span>{{ board.regNm }}</span>
                      <div class="">
                        <span v-if="board.commentAt == 'Y'"><i class="far fa-comment-dots"></i> {{ board.commentCnt }}</span>
                        <p style="display: inline; margin-left: 20px" v-if="board.likeYn == 'N'" class="like"><i class="far fa-heart"></i> {{ board.likeCnt }}</p>
                        <p style="display: inline; margin-left: 20px" v-else class="like ed"><i class="fas fa-heart"></i> {{ board.likeCnt }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 일 단위 기준으로 끊고 광고 삽입 -->
            <div class="app_extanal">
              <img src="images/basic/img/external_img.png" alt="" style="visibility: hidden" />
            </div>

            <!-- <v-divider v-if="index < items.length - 1" :key="index"></v-divider> -->
          </div>
          <!-- <infinite-loading @infinite="infiniteHandler"></infinite-loading> -->
        </div>
      </div>

      <div class="write_btn" @click="goToCmWrite">
        <img src="images/basic/icon/write-w.svg" alt="" />
      </div>
    </div>
    <bottom-menu></bottom-menu>
  </main>
</template>

<script>
import TopMenu from "@/components/common/TopMenu";
import BottomMenu from "@/components/common/BottomMenu";
import { fetchEventDetail } from "@/api/event";
import { fetchCommunityBanners } from "@/api/banners";
import { fetchSelectedBoardList, fetchTabList, fetchSelectBestList, fetchNoticeList } from "@/api/boards";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    TopMenu,
    BottomMenu,
    Swiper,
    SwiperSlide,
  },
  created() {
    window.VueRoot=this;
    this.boardId = this.$store.state.selectedBoardId;
    fetchTabList().then((res) => {
      this.resultList = res.data.resultList;
      if(this.boardId == "") this.boardId = this.resultList[0].boardId;
      this.selectBoardList(this.boardId);
    });
    fetchCommunityBanners().then(({ data }) => {
      this.banner = data.bannerList;
    });
    fetchNoticeList({
      searchType: "community",
      recordCntOnPage: 2,
    }).then(({ data }) => {
      this.noticeList = data.resultList;
    });
  },
  mounted() {
    window.$(window).scroll(function () {
      if (window.$("body").hasClass("with-tab") === false) {
        var tabY = window.$("#community_body .list_div").offset();
        if (window.$(document).scrollTop() > tabY.top) {
          window.$("body").addClass("with-tab");
        } else {
          window.$("body").removeClass("with-tab");
        }
      } else {
        let tabY = window.$("#community_body .list_div").offset();
        if (window.$(document).scrollTop() > tabY.top) {
          window.$("body").addClass("with-tab");
        } else {
          window.$("body").removeClass("with-tab");
        }
      }
    });
    document.getElementById("icon_community").src = "images/basic/menu_icon/tabbar-community-on.svg";
    const offset = 50;
    window.addEventListener("scroll",this.scrollCheck)
  },
  computed: {
    reportUsers(){
      var reportUsersArray = this.$store.state.report_users;
      if(reportUsersArray == undefined) return [];
      return reportUsersArray;
    }
  },
  destroyed() {
     window.removeEventListener('scroll', this.scrollCheck);
  },
  data() {
    return {
      startRender: false,
      banner: [],
      resultList: [],
      board: [],
      boardDetailList: [],
      boardLength: 0,
      pageIndex: 1,
      boardId: "",
      top_title: '<span id="top_title">커뮤니티</span>',
      listCnt: -1,
      startNttId: "",
      noticeList: [],
      boardRequested: false,
      communitySwiperOption: {
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
          loop: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
      },
    };
  },
  methods: {
    scrollCheck(){
      const offset = 50;
      var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,  document.documentElement.clientHeight,  document.documentElement.scrollHeight,  document.documentElement.offsetHeight );
      if ((window.innerHeight + window.scrollY) >= pageHeight - offset) {
          //console.log("You are at the bottom of the page.");
          this.fetchData();
      }
    },
    selectBoardList(id) {
      // 보드 리스트 select 시에 
      // 스크롤 최상위로 이동
      this.boardRequested = false;
      window.scrollTo(0, 0);

      const boardId = id;
      this.boardId = id;
      this.$store.commit("udtBoardId", id);

      fetchSelectBestList({
        boardId,
        recordCntOnPage: 5,
      }).then(({ data }) => {
        this.board = data.resultList;
        console.log(this.board);
      });

      this.pageIndex = 1;
      this.getDetailBoardList();
    },
    community_view(nttId) {
      var varUA = navigator.userAgent.toLowerCase();
      if (varUA.indexOf("android") > -1) {
        //ANDDROID
        let resolve =  this.$router.resolve({
        path: "/community_view",
        query: {
          boardId: this.boardId,
          nttId,
        },
        }).href;

        window.open(resolve,  "", "_blank");
      } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
        //IOS
        this.$router.push({
        path: "/community_view",
        query: {
          boardId: this.boardId,
          nttId,
        },
        });
      } else {
        this.$router.push({
        path: "/community_view",
        query: {
          boardId: this.boardId,
          nttId,
        },
        });
        //아이폰, 안드로이드 외
      }
    },
    getDetailBoardList() {
      const boardId = this.boardId;
      fetchSelectedBoardList({
        boardId,
        orderBy: "reg",
        orderType: "desc",
        pageIndex: this.pageIndex,
        recordCntOnPage: 10,
        groupData: "Y",
        startNttId: this.startNttId,
      }).then(({ data }) => {
        if (data.resultCode == "1000") {
          this.boardDetailList = data.resultList;
          this.listCnt = data.resultCnt;
          this.startNttId = data.startNttId;
          this.startRender = true;
        }
        
      });
    },
    fetchData() {
      if(this.boardRequested) return;
      this.boardRequested = true;
      console.log("fetch data");
      this.boardLength = 0;
      this.boardDetailList.filter((boards) => {
        boards.filter((board) => {
          this.boardLength += 1;
        });
      });
      if (this.boardLength < this.listCnt) {
        this.pageIndex += 1;
        const boardId = this.boardId;
        fetchSelectedBoardList({
          boardId,
          orderBy: "reg",
          orderType: "desc",
          pageIndex: this.pageIndex,
          recordCntOnPage: 10,
          groupData: "Y",
          startNttId: this.startNttId,
        }).then(({ data }) => {
          var firstDateWeek
          try{
            firstDateWeek = data.resultList[0][0].dateWeek;            
          }catch( e ){
              console.log(e)
          }
          
          const curIdx = this.boardDetailList.length - 1;
          const curDateWeek = this.boardDetailList[curIdx][0].dateWeek;
          this.startNttId = data.startNttId;
          if (firstDateWeek == curDateWeek) {
            this.boardDetailList[curIdx] = [...this.boardDetailList[curIdx], ...data.resultList[0]];
            for (let i = 1; i < data.resultList.length; i++) {
              this.boardDetailList.push(data.resultList[i]);
            }
          } else {
            this.boardDetailList = [...this.boardDetailList, ...data.resultList];
          }
          this.$forceUpdate();
          this.boardRequested = false;
        });
      }
    },
    goToCmWrite() {
      this.$router.push({
        path: "/community_write",
        query: { boardId: this.boardId },
      });
    },
    goToDetailPage(list) {
      if (list.linkType == "noticeDetail") {
        this.$router.push({
          path: "/noticeDetail",
          query: { nttId: list.nttId },
        });
      }
      if (list.linkType == "boardDetail") {
        this.$router.push({
          path: "/community_view",
          query: { boardId: list.boardId, nttId: list.nttId },
        });
      }
      if (list.linkType == "eventDetail") {
        fetchEventDetail({
          nttId:list.nttId
        }).then(({ data }) => {
          var event_status = data.result.status;
          var url = "/ongoingEvent";
          switch(event_status){
            case "ING":  url = "/ongoingEvent"; break;
            case "READY":url = "/upcomingEvent"; break;
            case "END":  url = "/endedEvent"; break;
          }
          this.$router.push({
            path: url,
            query: { nttId: list.nttId },
          });
        });
      }
      if (list.linkType == "link") {
        var link = list.linkUrl;
        this.$router.push({
          path: link,
        });
        //this.$router.push(`/${list.linkUrl}`);
      }
    },
  },
};
</script>

<style scoped>
.unlisted_wrap {
  text-align: center;
}

.unlisted_wrap .title {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 400;
}

.unlisted_wrap .sub_title {
  font-size: 13px;
  color: #6f737a;
}

.notice_div {
  margin-top: 34px;
  background-color: #f2f3f6;
  border-radius: 5px;
  padding: 5px;
}
.notice_div table {
  width: 100%;
  font-size: 13px;
}
.notice_div tr {
  position: relative;
}

.notice_div tr {
  display: flex;
  align-items: center;
  height: 55px;
}
.notice_div tr::after {
  content: "";
  display: block;
  height: 1px;
  background-color: var(--Gray-Dark);
  width: 300%;
  transform-origin: left bottom;
  transform: scale(0.34);
  left: 0;
  bottom: 0;
  position: absolute;
  opacity: 0.3;
}
.notice_div tr:last-child::after {
  display: none;
}
.notice_div th {
  flex-grow: 0;
  min-width: 70px;
  text-align: left;
  margin-left: 7px;
}

.notice_div td {
  color: #737b84;
  flex-grow: 1;
  vertical-align: middle;
  min-width: 30px;
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice_div .more {
  text-align: right;
  margin-right: 8px;
}

#community_progress {
  height: 3px;
  bottom: 0;
  right: 0;
  top: initial;
  left: initial;
}

#community_top .swiper-container {
  padding-bottom: 10px;
}

#community_top #community_progress {
  background-color: #ebeef1 !important;
}
</style>
